export default __webpack_public_path__ + "static/NonDig-c70c6d141b73f41754cafe44e2d5c8a3.png";